import { MESSAGES_SERVICE } from "@/services/messages.service.js";

const state = {getMessagesByIdOutput: {}};

const actions = {
    //Service to get messages details
    getMessageById({ dispatch, commit }, coachingSessionId) {
        dispatch('alert/clear', null, { root: true });
        commit('getMessagesByIdRequest');

        MESSAGES_SERVICE.getMessageById(coachingSessionId)
            .then(
                output => {
                    commit('getMessagesByIdSuccess', output);
                },
                error => {
                    commit('getMessagesByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    }
};

const mutations = {
    //getMessagesById
    getMessagesByIdRequest(state) {
    },
    getMessagesByIdSuccess(state, output) {
        state.getMessagesByIdOutput = output;
    },
    getMessagesByIdFailure(state) {
        state.getMessagesByIdOutput = false;
    }
};

export const messages = {
    namespaced: true,
    state,
    actions,
    mutations
};